<template>
  <div>
    <data-table ref="dataTable" :option="option"> </data-table>
    <a-modal
      centered
      title="查看详情"
      :maskClosable="visible.maskClosable"
      v-model="visible.showModal"
      :footer="null"
    >
      <div v-html="details"></div>
    </a-modal>
  </div>
</template>
<script>
import { DataTable } from "@/components/dataTable";
import moment from "moment";
export default {
  components: {
    DataTable
  },
  data() {
    return {
      visible: {
        maskClosable: false,
        showModal: false
      },
      details: "",
      ModuleNameChange: "",
      DateBegin: "",
      DateEnd: "",
      Detail: ""
    };
  },
  created() {
    this.option = {
      headSearch: {
        width: "100%",
        colnum: 6,
        props: {
          labelSize: "small",
          showButton: false
        },
        content: [
          {
            label: "动作名称",
            name: "ActionName"
          },
          {
            label: "模块名称",
            name: "ModuleName",
            type: "select",
            placeholder: "请选择",
            api: "Common_GetSelect",
            param: {
              Types: "childmenu"
            },
            valueField: "Text",
            dataField: "Data.childmenu"
            // onChange: this.onChangeModuleName
          },
          {
            label: "操作人",
            name: "CreatorUserId",
            type: "select",
            placeholder: "请选择",
            api: "Common_GetSelect",
            param: {
              Types: "operater"
            },
            dataField: "Data.operater"
          },
          {
            label: "关键字",
            name: "KeyWord",
            props: {
              placeholder: "动作名称/详情/创建人"
            }
          },
          {
            label: "日期范围",
            name: "dateRange",
            type: "date-range-picker",
            colnum: 2
          }
        ],
        onSubmitBefore: values => {
          const json = {
            ...values
          };
          if (values.dateRange) {
            json.DateBegin =
              values.dateRange[0] !== null
                ? moment(values.dateRange[0]).format("YYYY-MM-DD")
                : "";
          }
          if (values.dateRange && values.dateRange.length > 1) {
            json.DateEnd =
              values.dateRange[1] !== null
                ? moment(values.dateRange[1]).format("YYYY-MM-DD")
                : "";
          }
          json.KeyWord = values.KeyWord;
          return json;
        }
      },
      grid: {
        api: "SystemLog_List",
        columns: [
          {
            title: "序号",
            width: "8%",
            align: "center",
            type: "indexcolumn"
          },
          {
            title: "动作名称",
            width: "12%",
            dataIndex: "ActionName"
          },
          {
            title: "模块名称",
            width: "10%",
            dataIndex: "ModuleName"
          },
          {
            title: "创建人姓名",
            width: "12%",
            dataIndex: "CreatorUserName"
          },
          {
            title: "创建时间",
            dataIndex: "CreationTime",
            width: "12%"
          },
          {
            title: "详情",
            dataIndex: "Detail",
            customRender: text => {
              return (
                <span title={text} class="text-hide">
                  {text}
                </span>
              );
            }
          },
          {
            title: "操作",
            dataIndex: "Id",
            width: "12%",
            customRender: (text, record) => {
              if (text) {
                const viewDetails = {
                  click: () => {
                    this.viewDetails(record);
                  }
                };
                return (
                  <a-button size="small" type="link" {...{ on: viewDetails }}>
                    查看
                  </a-button>
                );
              }
            }
          }
        ]
      }
    };
  },
  methods: {
    viewDetails(row) {
      this.visible.showModal = true;
      this.details = row.Detail.replace(/\r\n/gi, "<br/>");
    },
    // onChangeModuleName(e, Data) {
    //   this.ModuleNameText = Data.Text;
    // },
    handleSearch() {
      this.$refs.dataTable.onSearchSubmit();
    }
  }
};
</script>

<style lang="less" scoped>
.text-hide {
  display: inline-block;
  width: 400px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.data-table /deep/.head .head-search-box {
  float: left;
}
</style>
